(function() {
	let module = {};

	/** Global init code for multisite instance */
	module.init = () => {

		// Get an element's distance from the top of the page
		function getElemDistance( elem ) {
			var location = 0;
			if (elem.offsetParent) {
				do {
					location += elem.offsetTop;
					elem = elem.offsetParent;
				} while (elem);
			}
			return location >= 0 ? location : 0;
		};		

		function stickyNavigation() {
			
			if (window.scrollY >= location) {
				elem.classList.add('fixed');
			} else {
				elem.classList.remove('fixed');
			}
		}

		function isInViewPort(element) {
			// Get the bounding client rectangle position in the viewport
			var bounding = element.getBoundingClientRect();
		
			// Checking part. Here the code checks if it's visible
			// Edit this part if you just want a partial visibility
			if (
				bounding.top <= ((window.innerHeight || document.documentElement.clientHeight) - 300) &&
				bounding.bottom >= 200
			) {
				return true;
			} else {
				return false;
			}
		}

		if(document.body.contains(document.querySelector('nav.history'))){
			var elem = document.querySelector('nav.history');
			var location = getElemDistance( elem );		  
			window.addEventListener('scroll', stickyNavigation);
			
			var decades = document.querySelectorAll(".history__decade");		

			if(decades){
				decades.forEach(function (decade, index) {
					window.addEventListener('scroll', function (event) {
						if (isInViewPort(decade)) {
							document.getElementById("selector-"+decade.id).classList.add("selected");
						} else{
							document.getElementById("selector-"+decade.id).classList.remove("selected");
						}
					}, false);
				});
			}	

		}



	};

	var docReady = (callback) => {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
			// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
			// IE <= 8
			document.attachEvent('onreadystatechange', () => {
				if (document.readyState === 'complete') callback();
			});
		}
	};

	docReady(() => {
		module.init();
	});

	HBS.namespace('ASM.brand', module);
}());